import { http } from './shared';

export const AutocompleteService = {
  getOrganizations: (queryParams) => http.get(`/auto_completes/organizations`, queryParams),
  getCommunities: (queryParams) => http.get(`/auto_completes/communities`, queryParams),
  getMembers: (queryParams) => http.get(`/auto_completes/users`, queryParams),
  getCommunityUsers: (queryParams) => http.get(`/auto_completes/community_users`, queryParams),
  getProgramUsers: (queryParams) => http.get(`/auto_completes/program_users`, queryParams),
};
